import { connect } from 'react-redux';

import { CollectionMetricsPreview } from './CollectionMetricsPreview';

export default connect((state: any) => ({
  sidebarOpened: state.sidebar.open,
}))(CollectionMetricsPreview);
